"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopNodeMenu = void 0;
const react_1 = __importStar(require("react"));
const graphql_zeus_1 = require("graphql-zeus");
const index_1 = require("../components/index");
const index_2 = require("../../icons/index");
const index_3 = require("../ContextMenu/index");
const typestyle_1 = require("typestyle");
const trees_1 = require("../../../state/containers/trees");
const Colors_1 = require("../../../Colors");
const NodeMenuContainer = typestyle_1.style({
    position: 'absolute',
    top: 35,
    zIndex: 2,
});
exports.TopNodeMenu = ({ node, onDelete, onDuplicate }) => {
    const { tree, setTree } = trees_1.useTreesState();
    const [menuOpen, setMenuOpen] = react_1.useState();
    const hideMenu = () => {
        setMenuOpen(undefined);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        node.data.type !== graphql_zeus_1.TypeDefinition.ScalarTypeDefinition &&
            node.data.type !== graphql_zeus_1.TypeDefinition.EnumTypeDefinition &&
            node.data.type !== graphql_zeus_1.ValueDefinition.EnumValueDefinition && (react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                setMenuOpen('field');
            }, title: "Click to add field" },
            react_1.default.createElement(index_2.Plus, { height: 10, width: 10 }),
            menuOpen === 'field' && (react_1.default.createElement("div", { className: NodeMenuContainer },
                react_1.default.createElement(index_3.NodeAddFieldMenu, { node: node, hideMenu: hideMenu }))))),
        node.data.type === graphql_zeus_1.TypeDefinition.EnumTypeDefinition && (react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                var _a;
                node.args = [
                    ...(node.args || []),
                    {
                        data: {
                            type: graphql_zeus_1.ValueDefinition.EnumValueDefinition,
                        },
                        name: 'enumValue' + ((((_a = node.args) === null || _a === void 0 ? void 0 : _a.length) || 0) + 1),
                        type: {
                            name: graphql_zeus_1.ValueDefinition.EnumValueDefinition,
                        },
                    },
                ];
                setTree(Object.assign({}, tree));
            }, title: "Click to add field" },
            react_1.default.createElement(index_2.Plus, { height: 10, width: 10 }))),
        (node.data.type === graphql_zeus_1.TypeDefinition.ObjectTypeDefinition ||
            node.data.type === graphql_zeus_1.TypeDefinition.InterfaceTypeDefinition) && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                    setMenuOpen('interface');
                }, title: "Click to implement interface" },
                react_1.default.createElement(index_2.Interface, { height: 10, width: 10 }),
                menuOpen === 'interface' && (react_1.default.createElement("div", { className: NodeMenuContainer },
                    react_1.default.createElement(index_3.NodeImplementInterfacesMenu, { node: node, hideMenu: hideMenu })))))),
        node.data.type !== graphql_zeus_1.Instances.Directive && (react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                setMenuOpen('directive');
            }, title: "Click to add directive" },
            react_1.default.createElement(index_2.Monkey, { height: 10, width: 10 }),
            menuOpen === 'directive' && node.data.type !== graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition && (react_1.default.createElement("div", { className: NodeMenuContainer },
                react_1.default.createElement(index_3.NodeAddDirectiveMenu, { node: node, hideMenu: hideMenu }))),
            menuOpen === 'directive' && node.data.type === graphql_zeus_1.TypeSystemDefinition.DirectiveDefinition && (react_1.default.createElement("div", { className: NodeMenuContainer },
                react_1.default.createElement(index_3.NodeDirectiveOptionsMenu, { node: node, hideMenu: hideMenu }))))),
        node.data.type === graphql_zeus_1.TypeDefinition.ObjectTypeDefinition && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                    setMenuOpen('operations');
                }, title: "Click set schema query, mutation, subscription" },
                react_1.default.createElement(index_2.Tick, { height: 10, width: 10, fill: Colors_1.Colors.grey[0] }),
                menuOpen === 'operations' && (react_1.default.createElement("div", { className: NodeMenuContainer },
                    react_1.default.createElement(index_3.NodeOperationsMenu, { node: node, hideMenu: hideMenu })))))),
        react_1.default.createElement("div", { className: 'NodeIconArea', onClick: () => {
                setMenuOpen('options');
            }, title: "Click to see node actions" },
            react_1.default.createElement(index_2.More, { height: 10, width: 10 }),
            menuOpen === 'options' && (react_1.default.createElement("div", { className: NodeMenuContainer },
                react_1.default.createElement(index_1.Menu, { hideMenu: hideMenu },
                    react_1.default.createElement(index_1.MenuScrollingArea, null,
                        react_1.default.createElement(index_1.DetailMenuItem, { onClick: onDelete }, "Delete node"),
                        onDuplicate && react_1.default.createElement(index_1.DetailMenuItem, { onClick: onDuplicate }, "Duplicate node"))))))));
};
